import {
  Integration_Handler_Names_Enum,
  Integration_Names_Enum,
  Integration_Service_Names_Enum,
} from '@main/graphql/types.generated';

import type { IntegrationConfig } from '../lib/integration-config';
import type { IntegrationSelector } from '../lib/integration-selector';
import * as allConfigs from './configs-all';

const registry = new Map<
  Integration_Names_Enum,
  Map<Integration_Service_Names_Enum, Map<Integration_Handler_Names_Enum, IntegrationConfig>>
>();

Object.values(allConfigs).forEach(registerIntegrationConfig);

function registerIntegrationConfig(config: IntegrationConfig) {
  let serviceMap = registry.get(config.service.connector.provider);
  if (!serviceMap) {
    serviceMap = new Map();
    registry.set(config.service.connector.provider, serviceMap);
  }
  let configMap = serviceMap.get(config.service.name);
  if (!configMap) {
    configMap = new Map();
    serviceMap.set(config.service.name, configMap);
  }
  configMap.set(config.name, config);
  return config;
}

export function findRegisteredIntegrationServices(providerName: Integration_Names_Enum) {
  return registry.get(providerName);
}

export function getRegisteredIntegrationServices(providerName: Integration_Names_Enum) {
  const services = findRegisteredIntegrationServices(providerName);
  if (!services) {
    throw new Error(`No integration services registered for provider "${providerName}".`);
  }
  return services;
}

export function getRegisteredIntegrationConfigs(
  providerName: Integration_Names_Enum,
  serviceName: Integration_Service_Names_Enum,
) {
  return registry.get(providerName)?.get(serviceName);
}

export function findRegisteredIntegrationConfig({
  providerName,
  serviceName,
  handlerName,
}: IntegrationSelector) {
  return registry.get(providerName)?.get(serviceName)?.get(handlerName);
}

export function getRegisteredIntegrationConfig(selector: IntegrationSelector) {
  const config = findRegisteredIntegrationConfig(selector);
  if (!config) {
    throw new Error(
      `No integration config registered for selector "${selector.providerName}.${selector.serviceName}.${selector.handlerName}".`,
    );
  }
  return config;
}
